<template>
  <section class="grid grid-cols-1 md:grid-cols-3 gap-11">
    <div v-for="can in candidates" :key="can.id">
      <div
        class="mt-10 text-center shadow-xl p-8 rounded hover:bg-blue-200 transition duration-500 ease-in"
      >
        <div class="flex justify-center">
          <img class="w-2/4" :src="can.image" alt="" />
        </div>
        <div class="flex items-center justify-center mt-4">
          <p class="font-medium">{{ can.name }}</p>
          <i class=" ml-2 fas fa-check-circle inline-block text-green-400"></i>
        </div>

        <div class="flex items-center justify-center mt-4">
          <p class="ml-2 text-sm">{{ can.role }}</p>
        </div>

        <div class="flex justify-between items-center px-4 mt-4">
          <div>
            <p class="font-light">Sex</p>
            <p class="font-bold">{{can.sex}}</p>
          </div>
          <div>
            <p class="font-light">Voters</p>
            <p class="font-bold">{{can.voters}}</p>
          </div>
          <div>
            <p class="font-light">Vote</p>
            <p class="font-bold">{{can.vote}}</p>
          </div>
        </div>

        <button
          @click="contact(can.id)"
          class="w-full mt-6 px-4 py-2 border border-indigo-600 text-indigo-600 mb-4 font-medium rounded hover:text-white hover:bg-indigo-500 transition focus:outline-none"
        >
          VOTE
        </button>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  props: ["candidates"],
  emit: ["contact"],
  data(){
  return{
    isTestnet:true,
    voteStatus:null
  }
  },
  methods: {
   async contact(id) {

      const voteStatusResponse = await fetch(
        `${this.nodeUrl}/addresses/data/${this.dAppAddress}/${
          id.split('_')[0]
        }_status`
      )
      const voteStatus = await voteStatusResponse.json()
      this.voteStatus = voteStatus
      console.log(this.voteStatus.value)


      this.$emit("contact", id, this.voteStatus);
    },
  },


   computed: {
    nodeUrl() {
      return this.isTestnet
        ? 'https://nodes-testnet.wavesnodes.com'
        : 'https://nodes.wavesplatform.com'
    },
    dAppAddress() {
      return this.isTestnet
        ? '3MsCcWZK2H5fR6xc6hJy6Mw1iaH47NWjZpg'
        : '3PPiE3H2Xrd1e5cqEs39ezVDMtRWcgJ1HgN'
    },
  },
};
</script>

<style></style>
